module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am25-5e737b73a79c05643acec97c1d29c736.jpg";